/* ──────────────────────────────────────────────────────────
   Payroll Code Setup  – very small, no external grids
   ────────────────────────────────────────────────────────── */
   import React, { useState } from "react";
   import PropTypes          from "prop-types";
   
   export default function PayrollCodeSetup({ initialRows, onSave, onClose }) {
     const [rows, setRows] = useState(initialRows);
   
     /* local helpers */
     const handleCellChange = (idx, key, value) =>
       setRows(prev =>
         prev.map((r, i) => (i === idx ? { ...r, [key]: value } : r)),
       );
   
     const addRow = () =>
       setRows(prev => [...prev, { employeeId: "", last: "", first: "", dept: "", rate: 0 }]);
   
     return (
       <div className="p-6 flex flex-col gap-4 h-full">
         <h3 className="text-xl font-semibold">Payroll Data Sheet / PR Code Setup</h3>
   
         {/* simple grid */}
         <div className="overflow-auto border rounded grow">
           <table className="min-w-full text-sm">
             <thead className="bg-gray-100 sticky top-0">
               <tr>
                 {["Employee ID", "Last Name", "First Name", "Department", "Rate"].map(h => (
                   <th key={h} className="p-2 border-b text-left">{h}</th>
                 ))}
               </tr>
             </thead>
             <tbody>
               {rows.map((r, i) => (
                 <tr key={i} className="odd:bg-white even:bg-gray-50">
                   <td className="p-1 border-b">
                     <input
                       className="w-full outline-none"
                       value={r.employeeId}
                       onChange={e => handleCellChange(i, "employeeId", e.target.value)}
                     />
                   </td>
                   <td className="p-1 border-b">
                     <input
                       className="w-full outline-none"
                       value={r.last}
                       onChange={e => handleCellChange(i, "last", e.target.value)}
                     />
                   </td>
                   <td className="p-1 border-b">
                     <input
                       className="w-full outline-none"
                       value={r.first}
                       onChange={e => handleCellChange(i, "first", e.target.value)}
                     />
                   </td>
                   <td className="p-1 border-b">
                     <input
                       className="w-full outline-none"
                       value={r.dept}
                       onChange={e => handleCellChange(i, "dept", e.target.value)}
                     />
                   </td>
                   <td className="p-1 border-b">
                     <input
                       type="number"
                       step="0.01"
                       className="w-full outline-none text-right"
                       value={r.rate}
                       onChange={e => handleCellChange(i, "rate", parseFloat(e.target.value) || 0)}
                     />
                   </td>
                 </tr>
               ))}
             </tbody>
           </table>
         </div>
   
         {/* actions */}
         <div className="flex justify-between">
           <div>
             <button
               onClick={addRow}
               className="px-3 py-1 border rounded bg-gray-100 hover:bg-cyan-100 text-xs"
             >
               + Add Row
             </button>
           </div>
           <div className="flex gap-2">
             <button
               onClick={() => onClose?.()}
               className="px-3 py-1 border rounded text-xs bg-gray-50 hover:bg-gray-100"
             >
               Cancel
             </button>
             <button
               onClick={() => onSave?.(rows)}
               className="px-3 py-1 border rounded text-xs bg-cyan-600 text-white hover:bg-cyan-700"
             >
               Save
             </button>
           </div>
         </div>
       </div>
     );
   }
   
   PayrollCodeSetup.propTypes = {
     initialRows: PropTypes.array,
     onSave:      PropTypes.func,
     onClose:     PropTypes.func,
   };
   
   PayrollCodeSetup.defaultProps = { initialRows: [] };
   